import * as React from "react";
import { Box, Tooltip, useColorModeValue, Button } from "@chakra-ui/react";
import { variant } from "theme/names";

export const DateButton = React.forwardRef<any, any>((props, ref) => {
  // @ts-ignore
  const { content, tooltipText = "", isActive = false, ...rest } = props;
  const backgroundColor = useColorModeValue(isActive ? "blue.100" : "white", isActive ? "gray.800": "gray.600")
  return (
    <Tooltip label={tooltipText}>
      <Button
        variant={props.isActive ? variant.Button.lightSelected : variant.Button.light}
        height="32px"
        lineHeight="1.2"
        transition="all 0.2s cubic-bezier(.08,.52,.52,1)"
        px="3"
        fontSize="12px"
        // height="24px"
        // lineHeight="1.2"
        // border="1px"
        // px="2"
        // fontSize="12px"
        // fontWeight="500"
        // backgroundColor={backgroundColor}
        // borderColor={useColorModeValue("#ccd0d5", "whiteAlpha.400")}
        // color={useColorModeValue("#4b4f56", "white")}
        // _hover={{ bg: useColorModeValue("cyan.100", "gray.700") }}
        // @ts-ignore
        ref={ref}
        // @ts-ignore
        {...rest}
      >
        {content}
      </Button>
    </Tooltip>
  );
});
